import { useState, useEffect } from 'react';
import isEmailValid, { isPhoneNumberValid } from '../utils/email-validation';
import useConsentCheck from '../hooks/use-consent-check';

const useWelcomeFormHook = (
  type, 
  handleSubmit,
  DisclaimerErrorMessage,
  ConsentErrorMessage) => {
  const [inputValue, setInputValue] = useState('');
  const [isOptIn, setIsOptIn] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);
  const [invalidInputError, setInvalidInputError] = useState('');
  const [submitError, setSubmitError] = useState('');
  const isMarketingConsentGranted = useConsentCheck('C0004');

  const validate = type === 'email' ? isEmailValid : isPhoneNumberValid;

  useEffect(() => {
    const isValid = validate(inputValue);
    if (!isValid && inputValue) {
      setInvalidInputError(`Please enter a valid ${type}`);
    } else {
      setInvalidInputError('');
    }
  }, [inputValue, isOptIn]);

  const handleOptInChange = (e) => {
    setIsOptIn(e.target.checked);
    setSubmitError('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setIsBlurred(true);

    if (!isMarketingConsentGranted) {
      setSubmitError(ConsentErrorMessage || 'Unable to complete request. Please review cookie settings.');
      return;
    }

    const isValid = validate(inputValue);
    if (!isValid) {
      setInvalidInputError(`Please enter a valid ${type}`);
    }

    if (!isOptIn) {
      setSubmitError(DisclaimerErrorMessage || 'Please check the box to acknowledge our terms and policies to continue.');
    }

    if (!isValid || !isOptIn) {
      return;
    }

    try {
      handleSubmit(inputValue, isOptIn);
    } catch (err) {
      setInvalidInputError(`Failed to submit ${type}. Please try again.`);
      console.error(`Error submitting ${type}:', err`);
    }
  };

  return {
    inputValue,
    setInputValue,
    isOptIn,
    setIsOptIn,
    isBlurred,
    setIsBlurred,
    invalidInputError,
    setInvalidInputError,
    submitError,
    setSubmitError,
    handleOptInChange,
    handleKeyDown,
    handleFormSubmit,
  };
};

export default useWelcomeFormHook;
